import Ansar from "../../../../_metronic/bankIcon/Ansar.png";
import Sepah from "../../../../_metronic/bankIcon/Sepah_0.png";
import Ayandeh from "../../../../_metronic/bankIcon/Ayandeh.png";
import Dey from "../../../../_metronic/bankIcon/Dey.png";
import EghtesadNovin from "../../../../_metronic/bankIcon/Eghtesad-novin.png";
import Kaspian from "../../../../_metronic/bankIcon/Kaspian.png";
import Keshavarzi from "../../../../_metronic/bankIcon/Keshavarzi.png";
import Ghavamin from "../../../../_metronic/bankIcon/Ghavamin_0.png";
import markazi from "../../../../_metronic/bankIcon/markazi.png";
import Maskan from "../../../../_metronic/bankIcon/Maskan.png";
import Mehr from "../../../../_metronic/bankIcon/Mehr_0.png";
import Mellat from "../../../../_metronic/bankIcon/Mellat.png";
import Melli from "../../../../_metronic/bankIcon/Melli.png";
import Parsian from "../../../../_metronic/bankIcon/Parsian_0.png";
import Pasargad from "../../../../_metronic/bankIcon/Pasargad.png";
import Refah from "../../../../_metronic/bankIcon/Refah_1.png";
import Resalat from "../../../../_metronic/bankIcon/Resalat.png";
import Saderat from "../../../../_metronic/bankIcon/Saderat_0.png";
import Saman from "../../../../_metronic/bankIcon/Saman.png";
import sarmayeh from "../../../../_metronic/bankIcon/sarmayeh_0.png";
import shahr from "../../../../_metronic/bankIcon/shahr_0.png";
import Tejarat from "../../../../_metronic/bankIcon/Tejarat_0.png";
import toseh from "../../../../_metronic/bankIcon/toseh.png";
import TosehTavon from "../../../../_metronic/bankIcon/Toseh-tavon.png";

const bankArray = [
  {
    id: 101,
    name: "انصار",
    imgPath: Ansar,
  },

  {
    id: 102,
    name: "آینده",
    imgPath: Ayandeh,
  },
  {
    id: 103,
    name: "دی",
    imgPath: Dey,
  },
  {
    id: 104,
    name: "اقتصاد نوین",
    imgPath: EghtesadNovin,
  },
  {
    id: 105,
    name: "کاسپین",
    imgPath: Kaspian,
  },
  {
    id: 106,
    name: "مرکزی",
    imgPath: markazi,
  },
  {
    id: 107,
    name: "مهر",
    imgPath: Mehr,
  },
  {
    id: 108,
    name: "ملت",
    imgPath: Mellat,
  },
  {
    id: 109,
    name: "صادرات",
    imgPath: Saderat,
  },
  {
    id: 110,
    name: "مسکن",
    imgPath: Maskan,
  },
  {
    id: 111,
    name: "پارسیان",
    imgPath: Parsian,
  },
  {
    id: 112,
    name: "ملی",
    imgPath: Melli,
  },
  {
    id: 113,
    name: "رفاه",
    imgPath: Refah,
  },
  {
    id: 114,
    name: "سرمایه",
    imgPath: sarmayeh,
  },
  {
    id: 115,
    name: "توسعه",
    imgPath: toseh,
  },
  {
    id: 116,
    name: "سامان",
    imgPath: Saman,
  },
  {
    id: 117,
    name: "کشاورزی",
    imgPath: Keshavarzi,
  },

  {
    id: 118,
    name: "قوامین",
    imgPath: Ghavamin,
  },

  {
    id: 119,
    name: "رسالت",
    imgPath: Resalat,
  },
  {
    id: 120,
    name: "شهر",
    imgPath: shahr,
  },
  {
    id: 121,
    name: "پاسارگاد",
    imgPath: Pasargad,
  },
  {
    id: 122,
    name: "تجارت",
    imgPath: Tejarat,
  },
  {
    id: 123,
    name: "توسعه و تعاون",
    imgPath: TosehTavon,
  },
  {
    id: 124,
    name: "سپه",
    imgPath: Sepah,
  },
];

export default bankArray;
